import { MyPlaylistsTabs } from '../features/myPlaylists';
import useWootricSurvey from '../hooks/useWootricSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
export const MyPlaylists = () => {
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(MyPlaylistsTabs, {});
};
export default MyPlaylists;